import React from 'react';
import PropTypes from 'prop-types';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function FeatureFlag({
    flag,
    flagValueToMatch = true,
    fallback,
    children
}) {
    const flags = useFlags();

    if (flags[flag] === flagValueToMatch) {
        return <>{children}</>;
    }

    // without this check
    if (fallback && (flags[flag] === null || flags[flag] === undefined)) {
        return null;
    }

    return <>{fallback}</> || null;
}

FeatureFlag.propTypes = {
    /** The LaunchDarkly flag to be evaluated. Flags are converted to camel
     * case, so "my-nice-flag" will be "myNiceFlag" in the React app */
    flag: PropTypes.string.isRequired,

    /** The content/component to be rendered if the flag's value evaluates to true */
    children: PropTypes.node.isRequired,

    /** Optional content/component rendered if the flag's value evaluates to false */
    fallback: PropTypes.node,

    /** The value to compare to the flag value coming from LaunchDarkly. Uses
     * strict equality. Use this to override the default of a boolean-type
     * flag where "true" means the feature is on and children should render */
    flagValueToMatch: PropTypes.any
}
